import { useIntl } from 'react-intl';

import { ILocalizedMenuEntry } from 'state/unified-menu/types';

import {
  ProductInformationContainer,
  ProductInformationDescription,
  ProductInformationTitle,
} from './styled';

interface IProductInformationProps {
  selectedProduct: ILocalizedMenuEntry;
}
export const ProductInformation: React.FC<IProductInformationProps> = ({ selectedProduct }) => {
  const { formatMessage } = useIntl();
  const title = formatMessage({ id: 'productInformation' });
  return (
    <ProductInformationContainer>
      <ProductInformationTitle accessibilityRole="header" accessibilityLevel={3}>
        {title}
      </ProductInformationTitle>
      {/* TODO: Should this be a sanity block content?  */}
      <ProductInformationDescription>
        {selectedProduct.description?.locale}
      </ProductInformationDescription>
    </ProductInformationContainer>
  );
};
